module.exports = __webpack_public_path__ + "img/social-banner.988de6dc.png";